import React, { useEffect, useState, useContext } from 'react'
import useStyles from './loginStyles';
import { MenuItem } from '@material-ui/core'
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { Context } from '../../Context';
import { getTypesDocumentAsync, validatePersonAsync } from '../../services/personService'
import { UseNotification } from '../../hooks/useNotification';
import { render } from '@testing-library/react';
import { addAuditLogin } from '../../services/auditService'
import Divider from '@material-ui/core/Divider';

export const Login = () => {
    const { activateAuth, removeAuth } = useContext(Context);
    const [documentsType, setdocumentsType] = useState([]);
    const [validateEmailError, setValidateEmailError] = useState(false)
    const [validateConfirmEmailError, setValidateConfirmEmailError] = useState(false)
    const [confirmEmailError, setConfirmEmailError] = useState(false)
    const [isLoading, setLoading] = useState(false)
    const [email, setEmail] = useState(false)
    const [confirmEmail, setConfirmEmail] = useState(false)
    const classes = useStyles();
    const validEmailRegex = RegExp(/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i);

    async function getDocumentsType() {
        try {
            var documents = await getTypesDocumentAsync();
            setdocumentsType(documents);
        } catch (error) {
            render(<UseNotification titleType={4} messageType={4} />)
        }
    }

    function getDataToAuditLogin (documentType, documentNumber) {
        return ({
            EventTypeLogin: 'LOGIN',
            DocumentTypeId : parseInt(documentType), 
            DocumentNumber : documentNumber
        })
    }

    async function validatePerson(event) {
        try { 
            var email = event.target[4].value
            var documentSelected = [...documentsType].find(dt => dt.documentTypeId == event.target[0].value)
            var documentNumber = event.target[2].value      
            if(!documentSelected || !documentNumber || !email){
                render(<UseNotification titleType={6} messageType={6} />)
            } else if(validateEmailError && !validateConfirmEmailError){
                render(<UseNotification titleType={7} messageType={7} />)
            } else if(validateConfirmEmailError && !validateEmailError){
                render(<UseNotification titleType={7} messageType={7} />)
            } else if(email != confirmEmail){
                render(<UseNotification titleType={7} messageType={8} />)
            } else {
                setLoading(true)
                var userValidated = await validatePersonAsync(documentNumber, event.target[0].value, email)
                let user = JSON.stringify({ DocumentNumber : userValidated.DocumentNumber, 
                                            DocumentType : parseInt(userValidated.DocumentType), 
                                            DocumentTypeDes : documentSelected.smallDescription,
                                            Email : email })
                if(userValidated.IsValid) {
                    activateAuth(user)
                    await addAuditLogin(getDataToAuditLogin(userValidated.DocumentType, userValidated.DocumentNumber))
                    setLoading(false)
                } else {
                    render(<UseNotification titleType={2} messageType={2} />)
                    removeAuth()
                    setLoading(false)
                }       
            }
        } catch (error) {
            render(<UseNotification titleType={4} messageType={4} />)
            removeAuth()
            setLoading(false)
        }
        
    }

    useEffect(() => {
        console.log('en el payment ', window.llave)
        getDocumentsType();
    }, []);

    const handleSubmit = e => {
      e.preventDefault()
      validatePerson(e)
    }

    const validateMail = e => {
        e.preventDefault()
        e.persist()
        var value = e.target.value
        setEmail(value)
        setValidateEmailError(!validEmailRegex.test(value))
        setConfirmEmailError(value != confirmEmail)
    }

    const validateMailConfirm = e => {
        e.preventDefault()
        e.persist()
        var value = e.target.value
        setConfirmEmail(value)
        setValidateConfirmEmailError(!validEmailRegex.test(value))
        setConfirmEmailError(value != email)
    }

    const handlePaste = e => {
        e.preventDefault();
        return false;
    };

    let fileReader;

    const handleFileRead = e => {
        const content = fileReader.result
        console.log(content)
    }

    return (
        <div className={classes.background} >
            <div className={classes.container}>
                <Paper elevation={3} className={classes.paper}>
                    <Typography variant="subtitle1" style={{fontWeight: "bold"}}>
                        Clientes
                    </Typography>
                    <form className={classes.form} onSubmit={handleSubmit}>
                        <Grid container spacing={1} alignItems="flex-end">
                            <TextField 
                                select
                                variant="outlined"
                                id="select"
                                name="documentType" 
                                label="Tipo de documento"
                                className = {classes.form}
                                defaultValue = '1'
                            >
                                {
                                    documentsType.map((document, index) => (
                                        <MenuItem key={index} value={document.documentTypeId}>{document.description}</MenuItem>
                                    ))
                                }
                            </TextField>
                        </Grid>

                        <Grid container spacing={1} alignItems="flex-end" style={{marginTop: 20}}>
                            <TextField 
                                required
                                id="document" 
                                label="Numero de documento"
                                variant="outlined" 
                                className = {classes.form}
                            />                             
                        </Grid>
                        
                        <Grid container spacing={1} alignItems="flex-end" style={{marginTop: 20}}>
                            <TextField 
                                required
                                error={validateEmailError || confirmEmailError}
                                id="email" 
                                label="Correo electrónico"
                                onChange={validateMail} 
                                onPaste={handlePaste}  
                                variant="outlined"  
                                className = {classes.form}  
                            />
                        </Grid>
                        <Grid container spacing={1} alignItems="flex-end" style={{marginTop: 20}}>
                            <TextField 
                                required
                                error={validateConfirmEmailError || confirmEmailError}
                                id="confirmEmail" 
                                label="Confirmar correo electrónico"
                                onChange={validateMailConfirm}   
                                onPaste={handlePaste}  
                                variant="outlined"  
                                className = {classes.form}  
                            />
                        </Grid>
                        <Divider variant="fullWidth" style={{marginTop: 20}} />
                        <Grid container spacing={1} alignItems="center" style={{marginTop:20}}>                                                
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                color="secondary"
                                className={classes.submit}
                                disabled={isLoading}
                            >
                                {isLoading ? "Cargando..." : "Ingresar"}
                            </Button>
                        </Grid>
                    </form>
                </Paper>
            </div>
        </div> 
    )
}